export class MaterialIssueIdreq{
    id:number;
    constructor(
        id:number
    ){
        this.id = id
    }
}



export class MaterialAllocationitemsIdreq{
    materialAllocationId:number;
    constructor(
        materialAllocationId:number
    ){
        this.materialAllocationId = materialAllocationId
    }
}